import { createApiClient, ApiError } from '@propmgt/shared';

/**
 * The single shared, typed API client instance for the SPA. It calls its own origin (the Worker
 * serves both the SPA and the API), and it echoes the CSRF token on mutations once the
 * AuthProvider sets it (from GET /api/auth/session or a login response) via `api.setCsrfToken`.
 *
 * ALL data access in the SPA goes through this client — no ad-hoc `fetch`.
 */
export const api = createApiClient();

export { ApiError };

/** Extract a human-readable message from an unknown thrown value (ApiError or otherwise). */
export function errorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    return err.body?.error ? err.body.error.replace(/_/g, ' ') : `Request failed (${err.status})`;
  }
  if (err instanceof Error) return err.message;
  return 'Something went wrong.';
}
